import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const BlogPostCard = ({ post, index }) => (
  <Link to={`/blog/${post.slug}`}>
    <motion.div
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
      className="group bg-white border border-[#E5E0D8]/60 overflow-hidden hover:shadow-lg transition-all h-full flex flex-col"
      data-testid={`blog-card-${index}`}
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs font-semibold text-[#1E3D66] tracking-wider uppercase px-2 py-1 bg-[#fafaf9]">
            {post.category}
          </span>
          <span className="flex items-center gap-1 text-xs text-[#9CA3AF]">
            <Clock size={12} /> {post.readTime}
          </span>
        </div>
        <h3
          className="text-base font-bold text-[#0B2A57] mb-2 leading-snug"
          style={{ fontFamily: 'Cabinet Grotesk' }}
        >
          {post.title}
        </h3>
        <p className="text-xs text-[#6B7280] leading-relaxed mb-4 flex-1">
          {post.excerpt}
        </p>
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#1E3D66] tracking-wider uppercase group-hover:gap-2 transition-all mt-auto">
          Read Article <ArrowRight size={14} />
        </span>
      </div>
    </motion.div>
  </Link>
);

export default BlogPostCard;
